import { getAppName } from "@/components/shapes/connection-frame/app-icons";
import { workToastAppNamed, workToastRecentApps } from "@/lib/work-toast-apps";
import type { WorkToastAppRef, WorkToastItem } from "@/stores/work-toast-store";
import { ToastLogoTile } from "./toast-pill";
import { WorkToastAppArt } from "./work-toast-app-icons";

/** Prefer the current app, retaining the latest app between unnamed steps. */
function computerApp(item: WorkToastItem): WorkToastAppRef | undefined {
  const apps = workToastRecentApps(item);
  const currentApp = item.computer?.appLabel?.trim();
  if (!currentApp) return apps[0];
  return (
    workToastAppNamed(apps, currentApp) ?? {
      appId: currentApp.toLowerCase(),
      label: currentApp,
      route: "ax",
      confirmed: true,
    }
  );
}

/** Actions and screenshots belong below the app identity, never in its slot. */
export function hasLiveComputerVisual(item: WorkToastItem): boolean {
  return Boolean(computerApp(item));
}

export function WorkToastLiveLogo({ item }: { item: WorkToastItem }) {
  const primary = computerApp(item);
  if (!primary) return null;
  return (
    <ToastLogoTile testId="work-toast-live-logo">
      <span
        key={primary.appId}
        className="grid h-full w-full place-items-center overflow-hidden rounded-full"
        title={primary.label ?? getAppName(primary.appId)}
        data-testid={`work-toast-live-app-${primary.appId}`}
        aria-hidden="true"
      >
        <WorkToastAppArt appRef={primary} projectId={item.projectId} size={28} />
      </span>
    </ToastLogoTile>
  );
}
